import RequiredIcon from '@navi/web-ui/lib/icons/RequiredIcon';
import Chip from '@navi/web-ui/lib/primitives/Chip/index';
import { Typography } from '@navi/web-ui/lib/primitives';
import cx from 'classnames';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import RenderingEngine from '.';
import { fetchSelectedQption } from '../actions';
import styles from '../index.module.scss';
import { IRenderingEngine, QuestionResponse } from '../interfaces/index.type';
import {
  getSortedOption,
  getStylesForChipInteractions,
  InteractionsEnum,
  selectedOptionChipStyles
} from '../utlis';
import { toast } from '@primitives/Toast';
import CancelCircleFilled from '@cp/assets/icons/CancelCircledFilled';

const GroupedOptions: React.FC<IRenderingEngine> = props => {
  const {
    question,
    register,
    error,
    toggleLoading,
    interactionType,
    setValue,
    lan,
    customerId,
    source,
    unregister,
    clearErrors,
    ...remainingProps
  } = props;
  const [moreQuestion, setmoreQuestion] = useState<Array<QuestionResponse>>([]);
  const [selectedChip, setselectedChip] = useState<string>();
  const { text, mandatory, referenceId, groupedOptions } = question;
  const sortedOptionGroups = useMemo(
    () => groupedOptions?.map(optionGroup => getSortedOption(optionGroup)),
    [groupedOptions]
  );

  const successCallback = useCallback((res: Array<QuestionResponse>) => {
    toggleLoading(false);
    setmoreQuestion([...res]);
  }, []);

  const failureCallback = useCallback(() => {
    toggleLoading(false);
    toast('something went wrong, please try selecting the option again', { type: 'error' });
  }, []);

  const handleChipChange = (changeEvent: string) => {
    setselectedChip(changeEvent);
    toggleLoading(true);
    fetchSelectedQption(
      lan,
      customerId,
      changeEvent,
      successCallback,
      interactionType,
      failureCallback
    );
  };

  const removeSelectedChip = useCallback(() => {
    setselectedChip('');
    setValue(`${source}_${referenceId}_option`, undefined);
    clearErrors(`${source}_${referenceId}_option`);
    setmoreQuestion([]);
  }, []);

  const renderChips = useMemo(
    () => (
      <>
        {sortedOptionGroups?.map(optionGroup => {
          return (
            // eslint-disable-next-line react/jsx-key
            <div
              className={cx({
                [styles.optionGroup]: !selectedChip,
                [styles.optionGroupWidget]: !selectedChip
              })}
            >
              {optionGroup?.map(option => {
                if (!selectedChip) {
                  return (
                    <div key={`${source}_${option.referenceId}`}>
                      <input
                        id={`${source}_${option.referenceId}`}
                        {...register(`${source}_${referenceId}_option`, {
                          required: mandatory,
                          onChange: (e: React.ChangeEvent<HTMLInputElement>) =>
                            handleChipChange(e.target.value)
                        })}
                        type={'radio'}
                        name={`${source}_${referenceId}_option`}
                        value={option.referenceId}
                        defaultValue={selectedChip}
                        className="hidden"
                      />
                      <label htmlFor={`${source}_${option.referenceId}`}>
                        <Chip
                          label={option.text}
                          wrapperClasses={cx([
                            'cursor-pointer',
                            styles.chip,
                            getStylesForChipInteractions(
                              option?.metadata?.interactionLevel,
                              InteractionsEnum.HOVER
                            )
                          ])}
                          labelClasses={styles.text}
                        />
                      </label>
                    </div>
                  );
                }
                if (selectedChip === option.referenceId) {
                  return (
                    <div key={`${source}_${option.referenceId}`}>
                      <Chip
                        key={option.referenceId}
                        label={option.text}
                        wrapperClasses={cx([
                          styles.chip,
                          getStylesForChipInteractions(
                            option?.metadata?.interactionLevel,
                            InteractionsEnum.ACTIVE_CHIP
                          )
                        ])}
                        RightAdornment={
                          <CancelCircleFilled
                            fillColor={getStylesForChipInteractions(
                              option?.metadata?.interactionLevel,
                              InteractionsEnum.ACTIVE_CANCEL_ICON
                            )}
                          />
                        }
                        labelClasses={styles.text}
                        onChipClick={removeSelectedChip}
                      />
                    </div>
                  );
                }
                return null;
              })}
            </div>
          );
        })}
      </>
    ),
    [selectedChip, source]
  );

  return (
    <>
      <div className={styles.input}>
        <Typography variant={'p4'} as={'p'}>
          {text} {<RequiredIcon />}
        </Typography>
      </div>
      <>
        <div className={cx(styles.questions)}>{renderChips}</div>
        {error?.[`${source}_${referenceId}_option`] && (
          <Typography variant="p5" className={styles.errorText}>
            Please select {text}
          </Typography>
        )}
      </>
      <div key={`${source}_${referenceId}_${text}`}>
        {moreQuestion.map(question => (
          <RenderingEngine
            key={`${source}_${referenceId}`}
            {...remainingProps}
            register={register}
            question={question}
            error={error}
            setValue={setValue}
            toggleLoading={toggleLoading}
            interactionType={interactionType}
            lan={lan}
            customerId={customerId}
            unregister={unregister}
            clearErrors={clearErrors}
            source={source}
          />
        ))}
      </div>
    </>
  );
};

export default GroupedOptions;
